import axios from 'axios';
import base64 from 'base-64';
import { setAxiosRequestTokenInterceptor } from '../common/setAxiosRequestTokenInterceptor';
import { setAxiosResponseInterceptor } from './setAxiosResponseInterceptor';

export const surveyAxiosClient = axios.create();

setAxiosRequestTokenInterceptor(surveyAxiosClient);
setAxiosResponseInterceptor(surveyAxiosClient);

// Automatically inject enterpriseId header from JWT claims for all survey API calls
surveyAxiosClient.interceptors.request.use((config) => {
	const accessToken = localStorage.getItem('accessToken');
	if (accessToken && config.headers) {
		try {
			const payload = accessToken.substring(accessToken.indexOf('.') + 1, accessToken.lastIndexOf('.'));
			const { enterpriseId } = JSON.parse(base64.decode(payload));
			if (enterpriseId) {
				config.headers['enterpriseId'] = enterpriseId;
			}
		} catch {
			// ignore decode errors — request proceeds without enterpriseId
		}
	}
	return config;
});
